import { Button, Icon, PostCard, UptownLink } from "@/components";
import Styles from "./PostGrid.module.css";

/**
 * @typedef {import("@prismicio/client").Content.PostGridSlice} PostGridSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<PostGridSlice>} PostGridProps
 * @param {PostGridProps}
 */
const PostGrid = ({ slice: { primary }, posts }) => {
  const greyBackground = primary.grey_background || false;
  const ctaLocation = primary?.cta_location;
  const maxCards = primary?.cards_to_display || 999;
  let cardsRendered = 0;

  // console.debug(
  //   "[Slice] ::: PostGrid ::: BEGIN",
  //   "\nprops: ",
  //   "\nprimary: ",
  //   primary,
  //   "\nposts: ",
  //   posts
  // );

  return (
    <section
      className={Styles.wrapper}
      style={{
        backgroundColor: greyBackground ? "var(--light-grey)" : "var(--white)",
      }}
    >
      <div className={Styles.headingContainer} data-contain="true">
        <h2 className={Styles.heading}>{primary?.heading}</h2>
        {ctaLocation === "Top" && primary?.cta_label && (
          <UptownLink link={primary?.category} className={Styles.ctaLink}>
            {primary?.cta_label} <Icon icon="ArrowRight" size={32} />
          </UptownLink>
        )}
      </div>
      <div
        className={Styles.container}
        data-contain="true"
        data-variant={primary?.card_variant}
      >
        {posts
          .sort(
            (a, b) =>
              (a?.data?.priority || Infinity) - (b?.data?.priority || Infinity)
          )
          .map((post, index) => {
            if (post?.data?.post_category?.uid === primary?.category?.uid) {
              if (cardsRendered < maxCards) {
                cardsRendered += 1;
                return (
                  <PostCard
                    key={index}
                    post={post}
                    variant={primary?.card_variant}
                  />
                );
              }
            }
          })}
      </div>
      {ctaLocation === "Bottom" && primary?.cta_label && (
        <div className={Styles.btnContainer}>
          <Button link={primary?.category} label={primary?.cta_label} />
        </div>
      )}
    </section>
  );
};

export default PostGrid;
